import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project import
import { ThemeMode } from 'config';

// assets
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PersonAddTwoToneIcon from '@mui/icons-material/PersonAddTwoTone';
import PeopleAltTwoToneIcon from '@mui/icons-material/PeopleAltTwoTone';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import AddIcon from '@mui/icons-material/Add';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import FormatListBulletedRoundedIcon from '@mui/icons-material/FormatListBulletedRounded';


const CampaignCard = ({ name, start_date, added, handleAddToCampaign, id, planName, created_at, v2, isList }) => {
    const theme = useTheme();

    if (v2) {
      const title = planName || name;
      const date = planName ? created_at : start_date;
      const TileIcon = isList ? FormatListBulletedRoundedIcon : CampaignOutlinedIcon;
      return (
        <Card
          sx={{
            p: 1.75,
            borderRadius: '14px',
            bgcolor: '#fff',
            border: '1px solid #e7eaf1',
            boxShadow: '0 2px 8px -5px rgba(17,25,54,0.25)',
            transition: 'all .15s ease',
            '&:hover': {
              borderColor: '#febd1c',
              boxShadow: '0 8px 20px -10px rgba(254,189,28,0.5)',
            },
          }}
        >
          <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0 }}>
            <Box
              sx={{
                width: 42,
                height: 42,
                borderRadius: '12px',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg,#111936,#2b3a78)',
              }}
            >
              <TileIcon sx={{ color: '#febd1c', fontSize: 22 }} />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{ fontWeight: 700, fontSize: '0.92rem', color: '#1f2433', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                {title}
              </Typography>
              <Typography sx={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', color: '#8a93a6', mt: '2px' }}>
                <CalendarMonthIcon sx={{ fontSize: 14 }} />
                {date}
              </Typography>
            </Box>
          </Stack>
          {added ? (
            <Button
              fullWidth
              disableElevation
              startIcon={<CheckCircleRoundedIcon />}
              sx={{
                mt: 1.5,
                textTransform: 'none',
                fontWeight: 700,
                borderRadius: '10px',
                background: '#e9f8ee',
                color: '#15803d',
                '&:hover': { background: '#dcf3e3' },
              }}
            >
              Added
            </Button>
          ) : (
            <Button
              fullWidth
              disableElevation
              startIcon={<AddIcon />}
              onClick={() => handleAddToCampaign(id)}
              sx={{
                mt: 1.5,
                textTransform: 'none',
                fontWeight: 700,
                borderRadius: '10px',
                background: '#febd1c',
                color: '#111936',
                boxShadow: '0 5px 12px -6px rgba(254,189,28,0.8)',
                '&:hover': { background: '#f0b016' },
              }}
            >
              Add
            </Button>
          )}
        </Card>
      );
    }

    return (
        <Card
            sx={{
                p: 2,
                bgcolor: theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'grey.50',
                border: '1px solid',
                borderColor: theme.palette.mode === ThemeMode.DARK ? 'dark.main' : 'grey.100',
                '&:hover': { borderColor: 'primary.main' }
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        {/* <Grid item>
                            <Avatar alt="User 1" src={avatar && getImageUrl(`${avatar}`, ImagePath.USERS)} />
                        </Grid> */}
                        <Grid item xs zeroMinWidth>
                            {planName && (
                                <Typography
                                    variant="h6"
                                    sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}
                                >
                                    {planName}
                                </Typography>
                            )}
                            <Typography
                                variant="h5"
                                sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}
                            >
                                {name}
                            </Typography>
                            {planName ? (
                                <Typography
                                variant="subtitle2"
                                sx={{ mt: 0.25, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}
                            >
                                <CalendarMonthIcon sx={{ mr: '6px', fontSize: '16px', verticalAlign: 'text-top' }} />
                                {created_at}
                            </Typography>
                            ): (
                            <Typography
                                variant="subtitle2"
                                sx={{ mt: 0.25, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}
                            >
                                <CalendarMonthIcon sx={{ mr: '6px', fontSize: '16px', verticalAlign: 'text-top' }} />
                                {start_date}
                            </Typography>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    {added ? (
                        <Button variant="contained" fullWidth startIcon={<PersonAddTwoToneIcon />}>
                            Added
                        </Button>
                    ) : (
                        <Button variant="outlined" fullWidth startIcon={<PeopleAltTwoToneIcon />} onClick={() => {
                            handleAddToCampaign(id);
                        }}>
                            Add
                        </Button>
                    )}
                </Grid>
            </Grid>
        </Card>
    );
};

CampaignCard.propTypes = {
    avatar: PropTypes.string,
    follow: PropTypes.number,
    location: PropTypes.string,
    name: PropTypes.string,
    planName: PropTypes.string
};

export default CampaignCard;
